module.exports = __webpack_public_path__ + "static/PartsBox-ee3a75700778cecb778e18ce55051ce8.png";